import store from "../localStorage";

const initialState = {
    isLoading: false,
    idsLoad: []
}

export default function loadManage(state = initialState, action) {
    switch (action.type) {
        case 'PAGE_LOADING':
            const newIds = state.idsLoad.includes(action.loadId) 
                ? state.idsLoad 
                : [...state.idsLoad, action.loadId];
            return {...state, idsLoad: newIds, isLoading: true};
            
        case 'PAGE_LOADED':
            const idsLoad = state.idsLoad.filter(id => id !== action.loadId);            
            return {...state, idsLoad, isLoading: idsLoad.length > 0};
        case 'CLEAN':
            return initialState;
        default:
            return state;
    }
}

export class pageLoadManageActions {
    // snow the spinner
    static start = (loadId) => store.dispatch({type: 'PAGE_LOADING', loadId: loadId});
    // hide the spinner
    static stop = (loadId) => store.dispatch({type: 'PAGE_LOADED', loadId: loadId});

    static clean = () => store.dispatch({type: "CLEAN"})
}
